import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f9f490e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "header-container"
};
const _hoisted_2 = {
  class: "header-menu-group"
};
const _hoisted_3 = {
  class: "header-menu header-menu-settings"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-menu-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-setting"
})], -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Settings", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header-menu-icon"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-logout"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
  const _component_el_dropdown = _resolveComponent("el-dropdown");
  const _component_SetLoginPassword = _resolveComponent("SetLoginPassword");
  const _component_SetPaymentPassword = _resolveComponent("SetPaymentPassword");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass(["iconfont", $data.isCollapse ? 'icon-nav-collapse' : 'icon-nav-collapsed']),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.isCollapseChange && $options.isCollapseChange(...args))
  }, null, 2), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_dropdown, {
    trigger: "click"
  }, {
    dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
      default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
        onClick: $options.openSetLoginPasswordPopup
      }, {
        default: _withCtx(() => [_createTextVNode("Set Login Password")]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_dropdown_item, {
        onClick: $options.openSetPaymentPasswordPopup
      }, {
        default: _withCtx(() => [_createTextVNode("Set Payment Password")]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    default: _withCtx(() => [_hoisted_5]),
    _: 1
  })]), _createElementVNode("div", {
    class: "header-menu header-menu-logout",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.handleLogout && $options.handleLogout(...args))
  }, [_hoisted_6, _createTextVNode(" Log Out ")])]), _createVNode(_component_SetLoginPassword, {
    ref: "setLoginPasswordRef",
    title: "Settings Login Password"
  }, null, 512), _createVNode(_component_SetPaymentPassword, {
    ref: "setPaymentPasswordRef",
    title: "Settings Payment Password"
  }, null, 512)]);
}